import { render, staticRenderFns } from "./InterfaceTest.vue?vue&type=template&id=071b96b8&"
import script from "./InterfaceTest.vue?vue&type=script&lang=js&"
export * from "./InterfaceTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports